/**
 * Theme-wide GSAP setup. Core library loads in `theme.liquid` as `gsap.min.js` before this file.
 *
 * Usage (same-origin deferred scripts run after DOM parse; prefer DOMContentLoaded for layout queries):
 *   document.addEventListener('DOMContentLoaded', () => {
 *     gsap.to('.my-element', { opacity: 1, duration: 0.5 });
 *   });
 *
 * ScrollTrigger: add `ScrollTrigger.min.js` to assets, load it after `gsap.min.js`, then:
 *   gsap.registerPlugin(ScrollTrigger);
 */
(function () {
  if (typeof gsap === 'undefined') {
    console.warn('[gsap-init] gsap is not available. Check that gsap.min.js is included in theme.liquid.');
  }
})();
